import styled from 'styled-components';
import { Link } from 'react-router-dom';

const PageNumber = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.mainColor};

  /* stylelint-disable */
  @media (hover: hover), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    &:hover {
      opacity: 0.75;
    }
  }
  /* stylelint-enable */
`;

export const PageNumberLink = PageNumber.withComponent(Link);
